import { useEffect, useRef, useState } from "react";
import { FieldsForMappingDropdown as UI } from "./ui/FieldsForMappingDropdown";
import { loadOptions } from "./lib";

export const FieldsForMappingDropdown = ({
  systemStringId,
  scopeStringId,
  primeDropdownPropsObj = {},
  toastRef,
  initialValueOptionObj,
  optionsObjStateRef,
}) => {
  const isOverlayShownRef = useRef(false);

  const filterObjState = useState({});
  const [filterObjStateValue] = filterObjState;

  const optionsObjState = useState({
    ...(initialValueOptionObj
      ? {
          selectedOptionGroup: {
            label: "Wybrano",
            items: [initialValueOptionObj],
          },
        }
      : {}),
  });

  if (optionsObjStateRef) optionsObjStateRef.current = optionsObjState;

  const onShowFunc = () => {
    if (isOverlayShownRef.current) return undefined;
    isOverlayShownRef.current = true;
    loadOptions(systemStringId,scopeStringId, filterObjState, optionsObjState, toastRef);
  };

  useEffect(() => {
    if (isOverlayShownRef.current) {
      const delay = setTimeout(() => {
        (async () => {
          await loadOptions(
            systemStringId,
            scopeStringId,
            filterObjState,
            optionsObjState,
            toastRef
          );
        })();
      }, 500);

      return () => clearTimeout(delay);
    }
  }, [filterObjStateValue]);

  return (
    <UI
      onShow={onShowFunc}
      optionsObjState={optionsObjState}
      primeDropdownPropsObj={primeDropdownPropsObj}
      filterObjState={filterObjState}
    />
  );
};
